import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'trainer-list',
};

const TrainerApi = createApi({
  reducerPath: 'trainer-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getTrainers: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.trainer.list, body),
    }),
    createTrainer: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.trainer.create,
        method: 'post',
        body: body,
      }),
    }),
    editTrainer: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.trainer.edit,
        method: 'post',
        body: body,
      }),
    }),
    deleteTrainer: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.trainer.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetTrainersQuery, useCreateTrainerMutation, useEditTrainerMutation, useDeleteTrainerMutation } =
  TrainerApi;
export { TrainerApi };
